import styled, { css } from 'styled-components'

import { mainColors, semanticColors } from '../../styles/colors'
import { _XS_Normal } from '../../styles/typography'

export interface DayCellStyleProps {
  $isSelectable: boolean
  $isOutsideMonth: boolean
  $isToday: boolean
  $isRangeStart: boolean
  $isRangeEnd: boolean
  $isInRange: boolean
  $isHighlighted: boolean
}

export const Cell = styled.button<DayCellStyleProps>`
  ${_XS_Normal};
  appearance: none;
  border: none;
  height: 28px;
  width: 100%;
  padding: 0;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: ${({ $isInRange }) => ($isInRange ? mainColors.accentExtraLight : 'transparent')};
  cursor: ${({ $isSelectable }) => ($isSelectable ? 'pointer' : 'default')};
  color: ${({ $isOutsideMonth, $isInRange, $isSelectable, $isToday }) => {
    if ($isInRange) return mainColors.accentMedium
    // A non-selectable day (incl. a blocked "today") stays muted so it never looks clickable.
    if (!$isSelectable || $isOutsideMonth) return mainColors.neutralDark
    if ($isToday) return mainColors.accentMedium
    return mainColors.neutralExtremelyDark
  }};

  ${({ $isHighlighted, $isRangeStart, $isRangeEnd }) =>
    $isHighlighted &&
    css`
      &::after {
        content: '';
        position: absolute;
        bottom: 3px;
        left: 50%;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        transform: translateX(-50%);
        background: ${$isRangeStart || $isRangeEnd
          ? mainColors.white
          : semanticColors.successMedium};
      }
    `}

  ${({ $isRangeStart, $isRangeEnd }) =>
    ($isRangeStart || $isRangeEnd) &&
    css`
      background: ${mainColors.accentMedium};
      color: ${mainColors.white};
    `}

  ${({ $isToday, $isRangeStart, $isRangeEnd, $isInRange }) =>
    $isToday &&
    !$isRangeStart &&
    !$isRangeEnd &&
    !$isInRange &&
    css`
      font-weight: 600;
    `}

  ${({ $isSelectable, $isRangeStart, $isRangeEnd }) =>
    $isSelectable &&
    css`
      &:hover {
        background: ${$isRangeStart || $isRangeEnd
          ? mainColors.accentMedium
          : mainColors.accentExtraLight};
      }
    `}
`
